import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { filter, keyBy, orderBy, values } from 'lodash';

class CompetitorRenderer extends Component {
  renderValue() {
    const { data, field } = this.props;
    if (!data) {
      return null;
    }
    const value = data[field];
    if (!value || value === undefined) {
      return <Fa name="spinner" spin className="text-muted" />;
    }
    const vendorReasons = value;

    if (!vendorReasons || vendorReasons.length === 0) {
      return null;
    }
    const uniqReasons = values(keyBy(vendorReasons, 'battlecard_url'));
    const total = uniqReasons.length;

    return uniqReasons.map((vendor, i) => {
      const isStrongest = vendor.is_strongest;
   
      const comps = [
        (
          <a
            key={vendor.id}
            href={vendor.battlecard_url}
            target="_blank"
            style={{ fontWeight: isStrongest ? 'bold' : null }}
          >
            {vendor.name} <Fa name="external-link" />
          </a>
        ),
      ];
      if (i < total - 1) {
        comps.push(
          (<span key={`${vendor.id}-comma`}>, </span>)
        );
      }
      return comps;
    });
  }

  render() {
    const isGrouped = this.props.node && this.props.node.group;
    if (!isGrouped) {
      return this.renderValue();
    }
    return null;
  }
}

CompetitorRenderer.propTypes = {
  data: PropTypes.shape({
    opportunity_id: PropTypes.string.isRequired,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
    expanded: PropTypes.bool,
  }),
  field: PropTypes.string.isRequired,
};
CompetitorRenderer.defaultProps = {
  data: null,
  node: null,
};

export default CompetitorRenderer;
